import us from '../../../defines';

export class ServerDownloader {
  /**
     * Constructor.
     * @param serviceLocator - Annotations service locator.
     */
  constructor (serviceLocator) {
    Object.defineProperty(this, '_serviceLocator', {
      get () {
        return serviceLocator;
      }
    });
  }

  /**
     * Downloads a tile to the user's machine.
     */
  async download (viewport, rectangle, zoom) {
    const angle = 0;
    const annotationsService = this._serviceLocator.annotationsService;
    const points = rectangle.scale(zoom).toPointArray();
    const layerId = await annotationsService.layers.maybeCreateLayerAndGetId('webviewer-snapshots');

    await annotationsService.regCreate({layerId, type: us.eAnTypes.rect, angle, zoom, points}, true);
  }
}



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/snapshot/capturing/ServerDownloader.js